import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  colors, SovosRaisedButton, SovosFlatButton
} from 's1-ui';
import TextField from 'commonComponents/textField';
import logo from 'resources/common-white-sovos-shipcompliant-logo.svg';

const { primaryNavy, neutralWhite, buttonOrange } = colors;

const styles = {
  pageContainer: {
    backgroundColor: primaryNavy,
    position: 'fixed',
    overflowY: 'auto',
    height: 'calc(100vh - 30px)',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
  },
  headerText: {
    marginTop: 60,
    color: neutralWhite,
    fontSize: 35,
    fontWeight: 100
  },
  description: {
    marginTop: 20,
    color: neutralWhite,
    fontSize: 16,
    fontWeight: 300,
    maxWidth: 400,
    textAlign: 'center'
  },
  submitButton: {
    marginTop: 40,
    textAlign: 'center'
  },
  backToLogin: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center'
  },
  backToLoginButton:{
    fontSize: 18
  },
  flatButton: {
    'button&:not(.another):not(.annoying):not(.specificity):not(.contest)': {
      padding: 0,
      textTransform: 'none'
    }
  },
};

const ForgotPasswordDisplay = ({
  classes, email, error, onChange, onKeyDown, onSubmit, backToLogin, loading, success
}) => (
  <div className={ classes.pageContainer }>
    <div>
      <img
        src={ logo }
        alt="shipcompliant_logo"
        height="50"
      />
    </div>
    <div className={ classes.headerText }>
      Reset Password
    </div>
    { success ? (
      <div className={ classes.description }>
        If an account exists with that email, a password reset link has been sent.
        Please check your inbox.
      </div>
    ) : (
      <div className={ classes.description }>
        Enter the email address associated with your account and we will send you
        a link to reset your password.
      </div>
    ) }
    { !success && (
      <div>
        <div style={ { paddingTop: 30 } }>
          <TextField
            InputProps={ {
              placeholder: 'Email',
              error: error !== undefined
            } }
            style={ { width: 350 } }
            label="Email"
            value={ email }
            onChange={ e => onChange(e.target.value) }
            onKeyDown={ onKeyDown }
          />
        </div>
        { error && (
          <div style={ { color: '#ff6b6b', marginTop: 10, fontSize: 14 } }>
            { error }
          </div>
        ) }
        <div className={ classes.submitButton }>
          <SovosRaisedButton
            color={ neutralWhite }
            backgroundColor={ buttonOrange }
            onClick={ onSubmit }
            disabled={ loading }
          >
            <span style={ { fontWeight: 300 } }>
              { loading ? 'SENDING...' : 'SEND RESET LINK' }
            </span>
          </SovosRaisedButton>
        </div>
      </div>
    ) }
    <div className={ classes.backToLogin }>
      <SovosFlatButton
        className={ classes.flatButton }
        color={ buttonOrange }
        onClick={ () => backToLogin() }
      >
        <span className={ classes.backToLoginButton }>Back to Login</span>
      </SovosFlatButton>
    </div>
  </div>
);

ForgotPasswordDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  backToLogin: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired
};

ForgotPasswordDisplay.defaultProps = {
  error: undefined
};

export default withStyles(styles)(ForgotPasswordDisplay);
